import z from 'zod'
import { decimalSchema } from '../../utils/schema'

// Spot取引履歴のスキーマ
const spotTradeSchema = z.object({
  /** 取引ペア */
  symbol: z.string(),
  /** 取引ID */
  id: z.number(),
  /** 注文ID */
  orderId: z.number(),
  /** 売買方向（BUY/SELL） */
  side: z.union([z.literal('BUY'), z.literal('SELL')]),
  /** 約定価格 */
  price: decimalSchema,
  /** 約定数量 */
  qty: decimalSchema,
  /** クオート通貨での約定金額 */
  quoteQty: decimalSchema,
  /** 手数料 */
  commission: decimalSchema,
  /** 手数料通貨 */
  commissionAsset: z.string(),
  /** 約定時間（UNIX時間・ミリ秒） */
  time: z.number(),
  /** 相手方ID（オプション） */
  counterpartyId: z.number().optional().nullable(),
  /** 作成・更新ID（オプション） */
  createUpdateId: z.number().optional().nullable(),
  /** メイカーかどうか */
  maker: z.boolean(),
  /** 買い手かどうか */
  buyer: z.boolean(),
})

// Futures取引履歴のスキーマ
const futuresTradeSchema = z.object({
  /** 取引ペア */
  symbol: z.string(),
  /** 取引ID */
  id: z.number(),
  /** 注文ID */
  orderId: z.number(),
  /** 売買方向（BUY/SELL） */
  side: z.union([z.literal('BUY'), z.literal('SELL')]),
  /** ポジション方向（LONG/SHORT/BOTH） */
  positionSide: z
    .union([z.literal('LONG'), z.literal('SHORT'), z.literal('BOTH')])
    .optional(),
  /** 約定価格 */
  price: decimalSchema,
  /** 約定数量 */
  qty: decimalSchema,
  /** クオート通貨での約定金額 */
  quoteQty: decimalSchema,
  /** 実現損益 */
  realizedPnl: decimalSchema.optional(),
  /** 手数料 */
  commission: decimalSchema,
  /** 手数料通貨 */
  commissionAsset: z.string(),
  /** 約定時間（UNIX時間・ミリ秒） */
  time: z.number(),
  /** メイカーかどうか */
  maker: z.boolean(),
  /** 買い手かどうか */
  buyer: z.boolean(),
})

// Spot・Futures両方に対応する統合スキーマ
export const tradeSchema = z.union([spotTradeSchema, futuresTradeSchema])

export const spotResponseSchema = z.array(spotTradeSchema)
export const futuresResponseSchema = z.array(futuresTradeSchema)

export type SpotTrade = z.infer<typeof spotTradeSchema>
export type FuturesTrade = z.infer<typeof futuresTradeSchema>
export type Trade = z.infer<typeof tradeSchema>
